import React from 'react';

import { Button } from '@column/column-ui-kit';

export const ReviewChangesButton: React.FC<{ onClick?: () => void }> = ({ onClick }) =>
  onClick ? (
    <Button onClick={onClick} size="small" variant="secondary">
      Review Changes
    </Button>
  ) : null;
